import React, { useState } from "react";
import { TextInput, View, StyleSheet, TouchableOpacity } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import Button from "@components/Button";
import ChevronRight from "@assets/svg/ChevronRight";
import EditPen from "@assets/svg/DbManagement/EditPen";

const CashCollection = ({
  totalCollectedFromCx,
  totalCollectedFromDb,
  onPress = () => {},
  onPressSubmit = () => {},
  showDivinder = false,
  reconEditingEnabled = false,
}) => {
  const [cashCollected, setCashCollected] = useState(
    parseInt(totalCollectedFromDb, 10) !== 0 ? totalCollectedFromDb : "",
  );
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = useState(
    parseInt(totalCollectedFromDb, 10) !== 0,
  );
  return (
    <View>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text variant="title_16">Cash collection</Text>
        {showDivinder && <View style={styles.divinder} />}
      </View>
      <View style={styles.container}>
        <TouchableOpacity
          testID="recon-cash-collected-modal-btn"
          style={styles.amountContainer}
          activeOpacity={0.6}
          onPress={onPress}
        >
          <Text variant="caption_2">Cash collected from customer</Text>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text variant="title_20"> ₹{totalCollectedFromCx}</Text>
            <ChevronRight
              pathFill={color.mediumBlacklightBlack}
              style={{ height: 12, width: 10, marginLeft: 2 }}
            />
          </View>
        </TouchableOpacity>
        <Text variant="caption_1" style={styles.enterText}>
          Enter collected cash
        </Text>
        <View style={styles.inputContainer}>
          <View style={styles.inputWrapper}>
            <Text variant="heading_24"> ₹</Text>
            <TextInput
              testID="recon-cash-collected-input"
              style={styles.input}
              placeholder="0.00"
              keyboardType="decimal-pad"
              placeholderTextColor={color.mediumBlacklightBlack}
              cursorColor={color.primary}
              maxLength={10}
              value={cashCollected}
              readOnly={true}
              editable={!isSubmitBtnDisabled && reconEditingEnabled}
              onChangeText={(text) => setCashCollected(text)}
            />
            {!isSubmitBtnDisabled && reconEditingEnabled ? null : (
              <TouchableOpacity
                testID="recon-cash-collected-edit-btn"
                onPress={() => setIsSubmitBtnDisabled(false)}
              >
                <EditPen />
              </TouchableOpacity>
            )}
          </View>
          <Button
            btnText="Submit"
            buttonWidth={100}
            onPress={() => onPressSubmit(cashCollected)}
            style={styles.submitButton}
            disabled={
              isSubmitBtnDisabled ||
              !reconEditingEnabled ||
              cashCollected === ""
            }
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    padding: 12,
    borderColor: color.lighterBlack,
    borderWidth: 1,
    marginVertical: 12,
    borderRadius: 16,
  },
  amountContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "rgba(242, 242, 242, 1)",
    padding: 8,
    paddingVertical: 6,
    borderRadius: 9,
    alignItems: "center",
  },
  enterText: {
    marginTop: 6,
    marginLeft: 2,
  },
  inputContainer: {
    flexDirection: "row",
    marginTop: 6,
    justifyContent: "space-between",
  },
  inputWrapper: {
    flexDirection: "row",
    backgroundColor: "rgba(242, 244, 251, 1)",
    borderRadius: 9,
    alignItems: "center",
    paddingHorizontal: 10,
    flex: 1,
    marginRight: 8,
  },
  input: {
    fontSize: 24,
    fontWeight: "bold",
    flex: 1,
  },
  submitButton: {
    marginLeft: 8,
  },
  divinder: {
    height: 0.5,
    flex: 1,
    backgroundColor: color.borderColor,
    marginTop: 8,
    marginLeft: 4,
  },
});

export default CashCollection;
